import React from 'react';
import { Container, Navbar } from 'react-bootstrap';

interface DocumentationPageProps {
    heading: string;
    children: React.ReactNode
}

const DocumentationPage = (props: DocumentationPageProps) => {
    return (
        <>
            <Navbar bg="white" sticky="top" style={{ zIndex: 10 }}>
                <Container fluid className="px-5 mb-0 py-2" >
                    <h4 className="mb-1"><strong>{props.heading}</strong></h4>
                </Container>
            </Navbar>
            <Container fluid className="py-5 px-5"  style={{ maxWidth: '1200px'}}>
                {props.children}
            </Container>
        </>
    )
}

export default DocumentationPage